/**
 * Returns a substring from the provided string starting from the index
 * after the last instance of the provided char.
 * Example: ('/path/to/filename', '/') => 'filename'
 * @param {string} str
 * @param {string} char
 */
export const substrAfterLastCharIndex = (str: string, char: string) => {
  const lastIndexOfChar = str.lastIndexOf(char);

  if (lastIndexOfChar < 0) return str;

  return str.substr(lastIndexOfChar + 1);
};

export function pluralizeWord(singularWord, pluralWord, count) {
  return count === 1 ? singularWord : pluralWord;
}

export function replaceWithData(str: string, data: Object): string {
  return Object.entries(data).reduce((result, [key, value]) => {
    return result.replace(key, value);
  }, str);
}

export function extractByRegex(str: string, regex: RegExp): Array<string> {
  if (!regex.global) {
    const match = regex.exec(str);

    return match && match[0] ? [match[0]] : [];
  }

  const matches = [];
  let match;

  while ((match = regex.exec(str)) !== null) {
    if (match.index === regex.lastIndex) {
      regex.lastIndex++;
    }

    matches.push(match[1]);
  }

  return matches;
}
